<template>
    <div>
        <div class="inputs">
            <b-form-group class="form-group" :state="rowsState.state">
                <template slot="label">
                    <div class="label">
                        {{ $t('nBox.xAxis') }}
                    </div>
                </template>
                <b-form-input
                    size="sm"
                    type="number"
                    :value="rows"
                    :state="rowsState.state"
                    @input="$emit('update:rows', parseInt($event))"
                />
            </b-form-group>
            <b-input-group-prepend class="input-separator" is-text
                >X</b-input-group-prepend
            >
            <b-form-group class="form-group" :state="columnsState.state">
                <template slot="label">
                    <div class="label">
                        {{ $t('nBox.yAxis') }}
                    </div>
                </template>
                <b-form-input
                    size="sm"
                    type="number"
                    :value="columns"
                    :state="columnsState.state"
                    @input="$emit('update:columns', parseInt($event))"
                />
            </b-form-group>
            <b-input-group-append is-text class="input-separator">{{
                `= ${quadrantsCount} quadrantes`
            }}</b-input-group-append>
        </div>
        <div class="d-flex">
            <b-form-invalid-feedback
                :state="rowsState.required && columnsState.required"
            >
                {{ $t('form.validations.required') }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback
                :state="rowsState.minValue && columnsState.minValue"
            >
                {{ $t('form.validations.minValue', { value: 1 }) }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback
                :state="rowsState.maxValue && columnsState.maxValue"
            >
                {{ $t('form.validations.maxValue', { value: 6 }) }}
            </b-form-invalid-feedback>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        rows: {
            type: [Number, String],
            required: true,
        },
        rowsState: {
            type: Object,
            default: null,
        },
        columns: {
            type: [Number, String],
            required: true,
        },
        columnsState: {
            type: Object,
            default: null,
        },
    },
    computed: {
        quadrantsCount() {
            const result = this.rows * this.columns
            return isNaN(result) || result > 36 ? 0 : result
        },
    },
}
</script>
<style lang="sass" scoped>
.inputs
    display: flex
    height: 60px

.form-group
    max-width: 100px

.input-separator
    align-self: center
    margin-top: 23px

.invalid-feedback
    max-width: 100px
</style>
